import React, { useState } from 'react'
import styled from 'styled-components'

import {
  Card as MuiCard,
  CardContent,
  IconButton,
  LinearProgress,
  Typography,
} from '@material-ui/core'
import { Edit as EditIcon } from '@material-ui/icons'
import { spacing } from '@material-ui/system'

import { HierarchyEditDialog } from 'src/modules/supply_chain/components/HierarchyEditDialog'
import { HierarchyTree } from 'src/components/Tree'
import { skuit } from 'src/services/skuit'
import { Hierarchy } from 'src/api/models'

const Card = styled(MuiCard)(spacing)
const Centered = styled.div`
  text-align: center;
`

interface HierarchyProps {
  facility?: {
    data: any
    isLoading: boolean
  }
  roots: Hierarchy[]
  title: string
  refresh?: () => void
}

export const HierarchyDetail = (props: HierarchyProps) => {
  const { roots, facility, refresh, title } = props
  const [hierarchyEditOpen, setHierarchyEditOpen] = useState(false)
  const isSuperUser = skuit.auth.isSuperUser()
  return (
    <Card mb={6}>
      {isSuperUser && facility && hierarchyEditOpen && facility && (
        <HierarchyEditDialog
          facility={facility.data}
          open={hierarchyEditOpen}
          handleClose={() => setHierarchyEditOpen(false)}
          onSave={refresh}
        />
      )}
      <CardContent>
        <Centered>
          <Typography variant="h5" component="h2">
            {title}
          </Typography>
          {!!facility && isSuperUser && (
            <IconButton size="small" onClick={() => setHierarchyEditOpen(true)}>
              <EditIcon fontSize="small" />
            </IconButton>
          )}
        </Centered>
        {facility?.isLoading ? (
          <LinearProgress />
        ) : (
          <HierarchyTree roots={roots} />
        )}
      </CardContent>
    </Card>
  )
}
